/**
 * @param  {any} val
 * @return {boolean}
 */
export default function exists (val) {
  return val != null;
}
